<google-map id="map" #map height="100%" width="100%" [center]="mapStart" [zoom]="zoom" (boundsChanged)="onTileLoaded()"
            (mapMousemove)="move($event)">
  <div *ngIf="withMarks">
    <map-marker #marker *ngFor="let markerPosition of markerPositions"
                [position]="markerPosition" [options]="markerOptions"
                (mapClick)="markerClick(markerPosition, $event)"></map-marker>
  </div>
  <map-circle *ngIf="withCircle" [radius]="circleRadius" [center]="circleCenter"
              [options]="{fillColor:'DarkGreen',strokeOpacity:0.0}"></map-circle>
  <map-info-window>Info Window content</map-info-window>
</google-map>
